import { render } from "./FieldGroundSpares.vue?vue&type=template&id=470e218d"
import script from "./FieldGroundSpares.vue?vue&type=script&lang=js"
export * from "./FieldGroundSpares.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__